import { load, store } from "helpers/filtersStorage";
import { RegionDryingPeriod } from "helpers/models";
import SignalRConnection from "services/signalRConnection";
import { getRegionDryingPeriodsList } from "sources/map";

class RegionDryingPeriodsManager {
    setRegionDryingPeriods: (data: RegionDryingPeriod[]) => void;
    connection: SignalRConnection;

    constructor(setRegionDryingPeriods: any) {
        this.setRegionDryingPeriods = setRegionDryingPeriods;

        this.connection = new SignalRConnection({
            url: "/signalr/map",
            actions: [
                { name: "ApplyRegionDryingPeriod", action: this.addRegions },
                { name: "DeleteRegionDryingPeriod", action: this.removeRegions },
            ],
            joinActionName: "Join",
            leaveActionName: "Leave",
        });

        const storedUpdatedAt = load("region-drying-periods-updated-at", null);
        const updateAt = storedUpdatedAt ? new Date(storedUpdatedAt) : undefined;
        getRegionDryingPeriodsList(
            updateAt && updateAt.getDate() === new Date().getDate() ? { updatedAt: { ge: updateAt } } : {},
        ).then(this.updateRegions);
    }

    updateRegions = (data: RegionDryingPeriod[]) => {
        const regionDryingPeriods = load("region-drying-periods", []);

        const dataObject = (data || []).reduce(
            (acc, item) => ({ ...acc, [item.id]: item }),
            {} as { [key: number]: RegionDryingPeriod },
        );
        const newRegions = regionDryingPeriods.map((region: RegionDryingPeriod) => {
            const returnValue = dataObject[region.id] ?? region;
            delete dataObject[region.id];
            return returnValue;
        });
        newRegions.push(...Object.values(dataObject));

        this.setRegionDryingPeriods(newRegions);
        store("region-drying-periods-updated-at", Date.now());
        store("region-drying-periods", newRegions);
    };

    disconnect = () => {
        this.connection.disconnect();
    };

    addRegions = ({ id }: { id: number }) => {
        getRegionDryingPeriodsList({ id }).then(this.updateRegions);
    };

    removeRegions = ({ id }: { id: number }) => {
        this.updateRegions([
            {
                id,
                regionId: 0,
                regionName: "",
                description: "",
                startedAt: "",
                endedAt: "",
                geometry: [],
                isDeleted: true,
                updatedAt: "",
            },
        ]);
    };
}

export default RegionDryingPeriodsManager;
